/* ==========================================================================
Swiper
========================================================================== */
import './swiper/card-slideshow.js';
import './swiper/testimonials-slideshow.js';

/* ==========================================================================
Elements
========================================================================== */
import './modal/account-register-modal.js';

/* ==========================================================================
Breadcrumbs
========================================================================== */
import './breadcrumbs/extended-breadcrumbs.js';

/* ==========================================================================
Datalayer
========================================================================== */
import './datalayer.js';